<template>
    <div class="grid grid-cols-12 gap-2">
        <div class="col-span-12 sm:col-span-8">
            <label :for="name" class="block text-sm text-white font-medium">
                {{ label }}
            </label>
            <div class="mt-1">
                <div class="mt-1 relative rounded-md shadow-sm">
                    <DatePicker v-model="selectedDate" mode="date" color="orange" :masks="masks" :min-date='new Date()' :attributes="attributes" locale="en-GB"
                        :popover="{ visibility: 'click' }">
                        <template v-slot="{ inputValue, inputEvents }">
                            <input type="text"
                                class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pr-10 pl-2 border-gray-300 sm:text-lg rounded-md py-2"
                                :value="inputValue" v-on="inputEvents"
                                readonly />
                        </template>
                    </DatePicker>
                    <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z">
                            </path>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-span-6 sm:col-span-4">
            <div>
                <label class="hidden sm:block text-sm text-white font-medium">&nbsp;</label>
                <div class="mt-1">
                    <div class="mt-1 relative rounded-md shadow-sm">
                        <select style="background-image: none"
                            class="appearance-none mt-1 block w-full pl-3 pr-10 text-gray-600 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-lg rounded-md py-2"
                            v-model="selectedTime">
                            <option v-for="n in timeList" :key="n" :value="n">{{ n }}</option>
                        </select>
                        <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <input type="hidden" :name="name" :value="timestamp">
</template>

<script>
import moment from 'moment';
import { DatePicker } from 'v-calendar';

export default {
    components: {
        DatePicker,
    },
    props: {
        modelValue: { required: false },
        label: { required: false, type: String },
        name: { required: false, type: String },
        attributes: { required: true },
    },
    data() {
        return {
            selectedDate: null,
            selectedTime: '12:00',

            timeList: [],
            masks: {
                input: 'DD-MM-YYYY',
            },
        };
    },
    computed: {
        timestamp() {
            if (this.selectedDate === null) return null;

            const date = moment(this.selectedDate).format('YYYY-MM-DD');
            return moment(`${date} ${this.selectedTime}`).format('YYYY-MM-DD HH:mm:ss');
        },
    },
    watch: {
        timestamp(value) {
            this.$emit('update:modelValue', value);
        },
        modelValue() {
            this.setDate();
        },
    },
    methods: {
        generateTimeDropdownOptions() {
            const current = moment().subtract(1, 'days').startOf('day');

            for (let i = 0; i < 96; i += 1) {
                this.timeList.push(current.format('HH:mm'));
                current.add(15, 'minutes');
            }
        },
        setDate() {
            this.selectedDate = new Date(this.modelValue);
        },
    },
    mounted() {
        this.generateTimeDropdownOptions();

        if (this.modelValue !== null) {
            this.setDate();
        }
    },
};
</script>
